class CartUpsell extends HTMLElement {
  constructor() {
    super();
    this.dataUrl = this.getAttribute('data-url');
    this.productId = this.getAttribute('data-product-id');
    this.fetchCartUpsell()
  }

  fetchCartUpsell() {
    if(!this.productId) {
        this.classList.remove('hidden')
        return;
    }
    fetch(`${this.dataUrl}&product_id=${this.productId}&section_id=cart-upsell`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const newCartUpsell = html.querySelector('cart-upsell')
      if(newCartUpsell) {
        this.innerHTML = newCartUpsell.innerHTML
        this.classList.remove('hidden')
      }
    })
    .catch((e) => {
      console.error(e)
    })
  }
}

customElements.define('cart-upsell', CartUpsell);

class CartUpsellProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSlick()
  } 

  initSlick() {
    $('.cart-upsell-products').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: false
      })
  }
}

customElements.define('cart-upsell-products', CartUpsellProducts);

class CartUpsellProduct extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form')
    this.form.addEventListener('submit', this.handleSubmit.bind(this))
  }
  handleSubmit(event) {
    event.preventDefault()
    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({
        items: [{
          id: this.form.querySelector('select[name="id"]').value,
          quantity: 1
        }]
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then((response) => response.json())
    .then((data) => {
      $(document).trigger('reloadCart')
    })
    .catch((error) => {
      console.error(error)
    })
  }
}
customElements.define('cart-upsell-product', CartUpsellProduct);